import { render, staticRenderFns } from "./BaseScreenBIPage.vue?vue&type=template&id=5c227960&scoped=true"
import script from "./BaseScreenBIPage.vue?vue&type=script&lang=ts"
export * from "./BaseScreenBIPage.vue?vue&type=script&lang=ts"
import style0 from "./BaseScreenBIPage.vue?vue&type=style&index=0&id=5c227960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c227960",
  null
  
)

export default component.exports